import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import SupersetDashboard from 'images/SupersetDashboard.png';
export default function ReportLogInDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('reportdashboardText', { ns: ['home'] })}</Typography>
      <img src={SupersetDashboard} style={{ width: '98vw' }} />
    </Box>
  );
}
